import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoggingService } from './logging/logging.service';
import { ResizeObserverDirective } from './directives/directive.resize.observer';


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        ResizeObserverDirective
    ],
    exports: [
        ResizeObserverDirective
    ]
})
export class PinItCoreModule {

    constructor(logger: LoggingService) {
        logger.debug('PinCoreModule --> constructor()');
    }

    public static forRoot(): ModuleWithProviders<PinItCoreModule> {
        return {
            ngModule: PinItCoreModule,
            providers: []
        };
    }

}
